module.exports = __webpack_public_path__ + "img/confirmed.3f2800a6.png";